export default {
  namespaced: true,

  state: () => {
    const auth =
      JSON.parse(localStorage.getItem("auth")) ||
      JSON.parse(sessionStorage.getItem("auth"));

    return {
      token: auth?.token || null,
      user: auth?.user || {},
      expiresAt: auth?.expiresAt || null,
    };
  },

  mutations: {
    setUser(state, payload) {
      state.token = payload.token;
      state.user = payload.user;
      state.expiresAt = payload.expiresAt || null;

      const storage = payload.expiresAt
        ? sessionStorage
        : localStorage;

      storage.setItem(
        "auth",
        JSON.stringify({
          token: payload.token,
          user: payload.user,
          expiresAt: payload.expiresAt,
        })
      );
    },

    clearUser(state) {
      state.token = null;
      state.user = {};
      state.expiresAt = null;

      localStorage.removeItem("auth");
      sessionStorage.removeItem("auth");
    },
  },

  getters: {
    isAuthenticated: (state) => {
      if (!state.token) return false;

      if (state.expiresAt && Date.now() > state.expiresAt) {
        return false;
      }

      return true;
    },

    currentUser: (state) => state.user,
  },
};
